"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publisherSubscriber = void 0;
var _generateId = require("./generateId");
var _array = require("./type-checks/array");
const publisherSubscriber = () => {
  const _id = (0, _generateId.generateId)("pub-sub");
  const _subscribers = {};
  const publish = (eventName, eventData) => {
    let result = false;
    if (!(0, _array.isArray)(_subscribers[eventName])) {
      result = false;
    } else {
      _subscribers[eventName].forEach(_ref => {
        let {
          callback
        } = _ref;
        callback(eventData);
        result = true;
      });
    }
    return result;
  };
  const subscribe = (eventName, callback) => {
    if (!(0, _array.isArray)(_subscribers[eventName])) {
      _subscribers[eventName] = [];
    }
    const supscriptionId = (0, _generateId.generateId)("subscription");
    _subscribers[eventName].push({
      callback,
      id: supscriptionId
    });
    return supscriptionId;
  };
  const unsubscribe = (eventName, subscriptionId) => {
    let result = false;
    if (!(0, _array.isArray)(_subscribers[eventName])) {
      result = false;
    } else {
      const subscriptionIndex = _subscribers[eventName].findIndex(_ref2 => {
        let {
          id
        } = _ref2;
        return id === subscriptionId;
      });
      if (subscriptionIndex > -1) {
        _subscribers[eventName].splice(subscriptionIndex, 1);
        result = true;
      }
    }
    return result;
  };
  return {
    id: _id,
    publish,
    subscribe,
    unsubscribe
  };
};
exports.publisherSubscriber = publisherSubscriber;